<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° da Carga</label
              >
            </div>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Expedição Inicial"
              v-model="dt_ini"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Expedição Final"
              v-model="dt_fim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_romaneio"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Romaneio</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

import { formatCNPJFromParts } from "../utils";

import moment from 'moment'
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      helpForm: new Form({ params: [], search: "" }),
      optionsLivStatus: [],
      status: [],
      num_romaneio: "",
      dt_ini: "",
      dt_fim: "",
      num_carga: "",
      transportadora: [],
      optionsTransportadora: [],
      isLoadingTransportadora: false,
      data_filter: []
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        status: this.status,
        num_romaneio: this.num_romaneio,
        dt_ini: this.formatDateSubmit(this.dt_ini),
        dt_fim: this.formatDateSubmit(this.dt_fim),
        num_carga: this.num_carga,
        transportadora: this.transportadora
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.status = "";
      this.num_romaneio = "";
      this.dt_ini = "";
      this.dt_fim = "";
      this.num_carga = "";
      this.transportadora = "";
      this.$events.fire("filter-reset");
    },
    getStatus() {
      this.helpForm.params = { tabela: "carga", coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, false, false);
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then(response => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach(obj => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach(obj => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach(obj => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      }
    }
  }
};
</script>